import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import FAQ from "../components/FAQ";
import SectionTitle from "../components/SectionTitle";

const SaleFAQ: React.FC = () => {
  const data = useStaticQuery<Queries.SaleFAQQuery>(query);
  const questions = data.faq?.questions
    ? data.faq.questions.filter((elem) => !!elem)
    : null;
  const faqs = questions
    ? questions.map((elem, i) => (
        <FAQ
          key={`faq-${i}`}
          question={elem.question}
          answer={elem.answer}
          slug={elem.slug}
        />
      ))
    : null;

  return (
    <div id="questions" className="mx-auto mb-16 max-w-[1200px] px-4">
      <SectionTitle>Frequently Asked Questions</SectionTitle>
      <div>{faqs}</div>
    </div>
  );
};

const query = graphql`
  query SaleFAQ {
    faq: faqsYaml(header: { eq: "Bidding on CLHbid.com" }) {
      header
      id
      questions {
        answer
        slug
        question
      }
    }
  }
`;

export default SaleFAQ;
